const PREFIX = 'ROLES/';
// eslint-disable-next-line import/prefer-default-export
export const ROLES_LIST = `${PREFIX}LIST`;
